( function( ) {

  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });

  $("#modalsubscribe").on('click',function(event) {
      event.preventDefault();
    $("#captchaModal").modal("show");
    setTimeout(function() {
      createRecaptcha();
    }, 100);
  });

  function submitsubs() {
    var dato = grecaptcha.getResponse();
    $("#modalsubscribe").closest('form').find('#validf').val(dato);
    $("#modalsubscribe").closest('form').submit();
  }

  function createRecaptcha() {
    grecaptcha.render("captcha", {sitekey: "6LckRREUAAAAAJtNkgM_9-1CwxN-x_AATqttI887", theme: "light", callback: "submitsubs"});
  }

	// soft para scrolls de anchors
	$("#mainmenu ul li a[href^='#']").on('click', function(e) {

   e.preventDefault();

   var hash = this.hash;

   if(hash == '#arts' || hash == '#graphic' || hash == '#cinema')
   {
    var salto = 350;
  } else if(hash == '#music')
  {
      var salto = 530;
  } else {
    var salto = 70;
  }
   // animate
   $('html, body').animate({
       scrollTop: $(hash).offset().top-salto
     }, 600, function(){

       // when done, add hash to url
       // (default click behaviour)
       window.location.hash = hash;
     });

	});


    $('.video-container').on('click', function(){
        var instance = $(this).data('vide');
        var video = instance.getVideoObject();
         $(video).get(0).paused ? $(video).get(0).play() : $(video).get(0).pause();
    });

    $('#videoma').vide({
        mp4: 'https://dl.dropbox.com/s/p5mropjos45g9zj/music_clean_1', // necesario en dropbox para que Chrome soporte el Loop, ya que tienen que ver con el boofer y el header del llamado al archivo.
        // webm: 'https://dl.dropbox.com/s/rz3zz6kbeoov4rt/mi4player-donotdelete',
        // ogv: 'https://dl.dropbox.com/s/t567v3lladsh91k/mi4player-donotdelete.ogg',
        poster: '/images/video-music'
    },{
        posterType: 'jpg',
        loop: true,
        autoplay: true,
        playbackRate: 1,
        muted: true,
        position: '50% 50%',
        volume: 0.3
    });

    $('#videodan').vide({
        mp4: 'https://dl.dropbox.com/s/mtm4j9d6ep02rmo/danza_clean_1', // necesario en dropbox para que Chrome soporte el Loop, ya que tienen que ver con el boofer y el header del llamado al archivo.
        // webm: 'https://dl.dropbox.com/s/rz3zz6kbeoov4rt/mi4player-donotdelete',
        // ogv: 'https://dl.dropbox.com/s/t567v3lladsh91k/mi4player-donotdelete.ogg',
        poster: '/images/video-music'
    },{
        posterType: 'jpg',
        loop: true,
        autoplay: true,
        playbackRate: 1,
        muted: true,
        position: '50% 50%',
        volume: 0.3
    });

    $('.overlayinsta').on('click', function(e){
        window.open('https://www.instagram.com/maradentrocabo/', '_blank');
    });


    $('.motorcerrado').on('click', function(){
      
        $( "#motorhome" ).animate({
        bottom: "0"
        }, 500);

        $('.motorcerrado').animate({
          height: "20"
        }, 200);

        $('.motorcerrado').css('visibility','hidden');
        $('.motorabierto').css('visibility','visible');

        

    });

     $('.motorabierto').on('click', function(){
      
        $( "#motorhome" ).animate({
        bottom: "-150"
        }, 500);

        $('.motorcerrado').animate({
          height: "20"
        }, 200);

        $('.motorabierto').css('visibility','hidden');
        $('.motorcerrado').css('visibility','visible');

        

    });


      

}) ( );

$(window).on('load',function(){
	/*
   * Nivo Lightbox for gallery
   */
  $('.mg-gallery-item a').nivoLightbox({ effect: 'fadeScale' });
  $('.mg-gallery-item2 a').nivoLightbox({ effect: 'fadeScale' });
});
